module.exports = __webpack_public_path__ + "img/IMG_2024_L_WoodMatted.cca0d4bb.jpg";